import {
    getSelectedTableView,
    getListViewState,
    isItemPartOperation,
    MailRowDataPropertyGetter,
    isMailListConversationView,
} from 'owa-mail-list-store';
import { getItemToShowFromNodeId } from 'owa-mail-store/lib/utils/conversationsUtils';
import type FlagType from 'owa-service/lib/contract/FlagType';
import type { ClientItemId } from 'owa-client-ids';
import type { ClientItem } from 'owa-mail-store';
import { getStore as getMailStore } from 'owa-mail-store/lib/store/Store';
import getEffectiveRowKeys from 'owa-mail-list-store/lib/utils/getEffectiveRowKeys';

export function getCurrentSelectionFlagType(itemId?: ClientItemId): FlagType | undefined | null {
    let flagType: FlagType | undefined | null;
    if (itemId) {
        const item: ClientItem | undefined = getMailStore().items.get(itemId.Id);
        flagType = item?.Flag;
    } else {
        const tableView = getSelectedTableView(true /* shouldGetEffectiveTableView */);
        if (!tableView) {
            return;
        }
        const rowKeys = tableView.isInVirtualSelectAllMode
            ? tableView.rowKeys
            : getEffectiveRowKeys(tableView);
        const selectedNodeIds = getListViewState().expandedConversationViewState.selectedNodeIds;

        // If the user has more than one item selected, return early. We don't show selected state here.
        if (rowKeys.length !== 1 || (isItemPartOperation() && selectedNodeIds.length !== 1)) {
            return undefined;
        }
        // If the user is in conversation view, we need to get the flag type from any of the items
        if (isMailListConversationView(tableView) && rowKeys.length === 1) {
            const conversation = getMailStore().conversations.get(
                MailRowDataPropertyGetter.getConversationId(rowKeys[0], tableView)
            );
            if (conversation) {
                for (const nodeId of conversation.conversationNodeIds ?? []) {
                    const flagState = getItemToShowFromNodeId(nodeId)?.Flag;
                    // If an item is flagged, return the flag state
                    if (flagState?.FlagStatus === 'Flagged') {
                        return flagState;
                    }
                }
            }
        }

        // Obtain current selected item's FlagType

        if (isItemPartOperation()) {
            // Expanded conversation view
            flagType = getItemToShowFromNodeId(selectedNodeIds[0])?.Flag;
        } else {
            flagType = MailRowDataPropertyGetter.getFlagType(rowKeys[0], tableView);
        }
    }
    return flagType;
}
